import React from 'react';

const LEVEL_COLORS = {
  NOMINAL: '#818CF8',
  ELEVATED: '#F59E0B',
  DISRUPTIVE: '#F97316',
  CRITICAL: '#EF4444',
};

const MON_COLORS = { LIVE: '#22C55E', DEGRADED: '#F59E0B', PARTIAL_COVERAGE: '#F59E0B', OFFLINE: '#EF4444' };

const LANGUAGES = [
  { code: 'en', label: 'EN' }, { code: 'es', label: 'ES' }, { code: 'fr', label: 'FR' },
  { code: 'ar', label: 'AR' }, { code: 'hi', label: 'HI' }, { code: 'zh', label: 'ZH' },
  { code: 'pt', label: 'PT' }, { code: 'de', label: 'DE' }, { code: 'ja', label: 'JA' },
  { code: 'ko', label: 'KO' }, { code: 'ru', label: 'RU' }, { code: 'it', label: 'IT' },
  { code: 'tr', label: 'TR' }, { code: 'ht', label: 'HT' },
];

export default function VegaTopBar({ timestamp, signalCount, totalInsights, state, scoring, sensorReadiness, onRefresh, onSwitchToNova, onSwitchToOrion, onSwitchToShow, onSwitchToAtlas, onSwitchToCrew, language, onLanguageChange }) {
  const levelColor = LEVEL_COLORS[state?.level] || '#818CF8';
  const monState = sensorReadiness?.state === 'NO_LIVE_SOURCES'
    ? 'OFFLINE'
    : sensorReadiness?.state === 'DEGRADED'
      ? 'PARTIAL_COVERAGE'
      : (scoring?.monitoringState || 'LIVE');
  const monColor = MON_COLORS[monState] || '#5A5A8A';
  const confidence = scoring?.finalConfidenceScore;

  return (
    <div className="vega-topbar" data-testid="vega-topbar">
      <div className="vega-topbar-status" style={{ background: levelColor }} data-testid="vega-status-dot" />
      <div className="vega-topbar-logo" data-testid="vega-logo">VEGA</div>
      <div className="vega-topbar-sep" />
      <div className="vega-topbar-sub" data-testid="vega-role-label">INFRASTRUCTURE INTELLIGENCE</div>
      <div className="vega-topbar-spacer" />

      <div className="vega-topbar-mon" style={{ color: monColor, borderColor: `${monColor}40` }} data-testid="vega-monitoring-state">
        {monState.replace('_', ' ')}
      </div>

      {scoring?.affectedDomains?.length > 0 && (
        <div className="vega-topbar-affected" data-testid="vega-affected-strip">
          {scoring.affectedDomains.map(d => d.replace(/_/g, ' ')).join(', ')}
        </div>
      )}

      <div className="vega-topbar-sep" />

      <div className="vega-topbar-level" style={{ color: levelColor, borderColor: `${levelColor}40` }} data-testid="vega-level-badge">
        {state?.level || 'NOMINAL'}
      </div>

      <div className="vega-topbar-metric" data-testid="vega-signal-count">
        <span className="vega-metric-val">{signalCount || 0}</span>
        <span className="vega-metric-label">SIGNALS</span>
      </div>
      <div className="vega-topbar-metric" data-testid="vega-insight-count">
        <span className="vega-metric-val">{totalInsights || 0}</span>
        <span className="vega-metric-label">INSIGHTS</span>
      </div>

      {confidence !== undefined && (
        <div className="vega-topbar-metric" data-testid="vega-confidence-metric">
          <span className="vega-metric-val">{Math.round(confidence)}%</span>
          <span className="vega-metric-label">CONFIDENCE</span>
        </div>
      )}

      <div className="vega-topbar-sep" />

      <select
        className="vega-lang-select"
        value={language}
        onChange={e => onLanguageChange(e.target.value)}
        data-testid="vega-language-selector"
      >
        {LANGUAGES.map(l => (
          <option key={l.code} value={l.code}>{l.label}</option>
        ))}
      </select>

      <div className="vega-topbar-sep" />

      <div className="vega-topbar-clock" data-testid="vega-clock">{timestamp || '--:--:-- UTC'}</div>
      <div className="vega-topbar-live" data-testid="vega-live-badge">{monState === 'LIVE' ? 'LIVE' : monState.replace('_', ' ')}</div>

      <button className="vega-topbar-refresh" onClick={onRefresh} data-testid="vega-refresh-btn">REFRESH</button>

      <div className="vega-topbar-nav" data-testid="vega-topbar-nav">
        <button className="vega-switch-btn" onClick={onSwitchToNova} data-testid="vega-switch-nova">NOVA</button>
        <button className="vega-switch-btn" onClick={onSwitchToOrion} data-testid="vega-switch-orion">ORION</button>
        {onSwitchToAtlas && <button className="vega-switch-btn" onClick={onSwitchToAtlas} data-testid="vega-switch-atlas" style={{ color: '#059669', borderColor: '#05966930' }}>ATLAS</button>}
        {onSwitchToCrew && <button className="vega-switch-btn" onClick={onSwitchToCrew} data-testid="vega-switch-crew" style={{ color: '#4de2c0', borderColor: '#4de2c040' }}>CREW</button>}
        <button className="vega-switch-btn" onClick={onSwitchToShow} data-testid="vega-switch-show">SHOW</button>
      </div>
    </div>
  );
}
